import React from "react";
import "./iconButton.css";
import { useTranslation } from 'react-i18next';

const IconButton = ({ iconSrc, buttonText, onClick }) => {
  const { t } = useTranslation();

  return (
    <button className="icon-button" onClick={onClick}>
      <div className="">
        <img src={iconSrc} alt="Icon" className="plus-icon" />
      </div>
      <div className="text-add-icon">{t(buttonText)}</div>
    </button>
  );
};

export default IconButton;
